import { createFileRoute, redirect } from '@tanstack/react-router';

// The standalone pricing page was removed - per-request USD prices live in the
// catalog ("API Prices"). Keep /pricing as a redirect so existing inbound links
// and blog posts that point at it land on the catalog instead of a 404.
export const Route = createFileRoute('/_site/pricing')({
  beforeLoad: () => {
    throw redirect({ to: '/catalog', statusCode: 301 });
  },
});
